import React from "react";

export const TabPanel = ({ children, value, index, ...other }) => {
  return (
    value === index && (
      <div
        className="flex-1 flex flex-col justify-between items-stretch overflow-hidden"
        role="tabpanel"
        {...other}
      >
        {children}
      </div>
    )
  );
};
